(ns ui.components.filter.view
  (:require))

(defn view
  [{:keys [filter/label filter-operator-label filter-value-label filter-active? on-delete]}]
  [:div
   {:class "flex gap-2 rounded-2xl duration-100"}
   [:div
    {:class "mb-0 px-2 py-1.5 
             flex flex-nowrap justify-start items-center flex-[0_0_auto] gap-8 
             duration-100 
             text-base-light-text text-sm leading-3 
             border border-solid border-base-light-border-paler hover:border-base-light-border focus:border-base-light-border 
             bg-base-light rounded-full"}
    [:span
     {:class "inline-flex gap-2 text-clip"}
     [:span
      {:class "font-semibold"}
      label]
     [:span
      filter-operator-label]
     (when filter-value-label
       [:span
        {:class "font-bold"}
        filter-value-label])]
    [:i.fas.fa-times-circle
     {:on-click on-delete}]]])

